export default __webpack_public_path__ + "images/05d819ec41f037838b09d86d8025bcac.png";